import {inject, Injectable} from '@angular/core';
import {Observable, of, tap} from 'rxjs';
import {CompanyService} from '@services/company.service';
import {ICompteAdministration} from '@models/compteAdministration.interface';

@Injectable({providedIn: 'root'})
export class CompanyDataService {

  private readonly companyService = inject(CompanyService);
  private readonly cache = new Map<string, ICompteAdministration>();

  load(siret: string): Observable<ICompteAdministration> {
    const hit = this.cache.get(siret);
    if (hit) {
      return of(hit);
    }
    return this.companyService.getCompanyBySiret(siret).pipe(
      tap(c => this.cache.set(siret, c))
    );
  }

  refresh(siret: string): Observable<ICompteAdministration> {
    this.cache.delete(siret);
    return this.load(siret);
  }
}
